export default {
  lang: {
    export: 'Εξαγωγή',
    successfully: 'Η εξαγωγή εργασιών δημιουργήθηκε με επιτυχία',
    pleaseJumpTo: 'Παρακαλώ πήδα.',
    uploadAndDownloadCenter: 'Αποστολή και Λήψη Κέντρου',
    check: 'Προβολή',
    exportAll: 'Επιβεβαίωση εξαγωγής όλου του περιεχομένου;',
    total: 'Σύνολο',
    confirm: 'Ντέιτα, επιβεβαιώστε την εξαγωγή;',
    error:
      'Ποσότητα των εξαγόμενων στοιχείων είναι 0, παρακαλώ αλλάξετε τα κριτήρια φίλτρου και δοκιμάστε ξανά',
  },
};
